import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
interface CTABandProps {
  headline?: string;
  subline?: string;
  buttonText?: string;
  variant?: 'cream' | 'sage';
}
export function CTABand({
  headline = '¿Lista para volver a sentirte bien?',
  subline = 'Acceso inmediato · Pago único · Garantía 60 días',
  buttonText = 'Quiero MOVÉ SUAVE™ ahora →',
  variant = 'cream'
}: CTABandProps) {
  const bg = variant === 'sage' ? 'bg-primary text-base' : 'bg-secondary/60 text-ink';
  const sublineColor = variant === 'sage' ? 'text-base/70' : 'text-ink/60';
  return <section className={`w-full px-5 md:px-8 py-20 md:py-32 ${bg}`} data-id="element-42">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="max-w-2xl mx-auto text-center flex flex-col items-center gap-8" data-id="element-43">
        <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight" data-id="element-44">
          {headline}
        </h3>
        <CTAButton variant={variant === 'sage' ? 'primary' : 'secondary'} data-id="element-45">
          {buttonText}
        </CTAButton>
        <p className={`text-[13px] md:text-sm ${sublineColor}`} data-id="element-46">{subline}</p>
      </motion.div>
    </section>;
}